class PushCartOmetria extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
    this.ometriaElement =
      this.querySelector('[data-ometria-sidecart-recs]') ||
      this.querySelector('#ometria-sidecart-recs')
    this.loadingText = this.querySelector('[data-loading-message]')
    this.container = this.closest('[data-ometriaContainer]')
    this.hasLoaded = false

    if (!this.container) {
      console.warn('Ometria sidecart: container not found')
      return
    }

    if (!this.ometriaElement) {
      console.warn('Ometria sidecart: target element not found')
      return
    }

    if (!this.ometriaElement.id) {
      console.warn('Ometria sidecart: target element missing id')
      return
    }
    this.ometriaTargetSelector = `#${this.ometriaElement.id}`

    // Only initialize on desktop (matching Nosto behavior)
    if (
      (window.innerWidth >= 901 && this.hasAttribute('data-desktop')) ||
      (window.innerWidth < 901 && this.hasAttribute('data-mobile'))
    ) {
      // Watch for drawer opening
      this.setupDrawerObserver()
    }
  }

  setupDrawerObserver () {
    // Watch for when the cart drawer opens
    // The body gets the class 'drw-Drawers-cart' when the cart drawer is open
    if (!this.container) return

    // Watch for body class changes
    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if (
          mutation.type === 'attributes' &&
          mutation.attributeName === 'class'
        ) {
          const isCartOpen = document.body.classList.contains(
            'drw-Drawers-cart',
          )

          // Show Ometria drawer when cart is open
          if (isCartOpen) {
            this.container.setAttribute('aria-hidden', 'false')
            this.resetCarouselScroll()
            if (!this.hasLoaded) {
              this.loadRecommendations()
            }
          } else {
            this.container.setAttribute('aria-hidden', 'true')
          }
        }
      })
    })

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['class'],
    })

    // Also check if cart drawer is already open
    if (document.body.classList.contains('drw-Drawers-cart')) {
      this.container.setAttribute('aria-hidden', 'false')
      this.resetCarouselScroll()
      if (!this.hasLoaded) {
        this.loadRecommendations()
      }
    }

    // Also listen for drawer open events as a backup
    if (window.BAO?.eventBus) {
      window.BAO.eventBus.addEventListener(
        window.BAO.EVENTS.OPEN_DRAWER,
        event => {
          if (event.detail?.key === 'cart' && !this.hasLoaded) {
            this.container.setAttribute('aria-hidden', 'false')
            this.resetCarouselScroll()
            this.loadRecommendations()
          } else if (event.detail?.key === 'cart') {
            this.container.setAttribute('aria-hidden', 'false')
            this.resetCarouselScroll()
          }
        },
      )
    }
  }

  loadRecommendations () {
    // Prevent loading multiple times
    if (this.hasLoaded) return

    // Check if graphenehc is available
    if (!window.graphenehc?.load) {
      console.warn('GrapheneHC not available for sidecart recommendations')
      return
    }

    // Mark as loading
    this.hasLoaded = true

    // Hide loading text
    if (this.loadingText) {
      this.loadingText.setAttribute('aria-hidden', 'true')
    }

    // Load recommendations using the dedicated sidecart template
    const sidecartUrl = window.location.pathname + window.location.search

    window.graphenehc.load({
      elements: [
        {
          id: 'sidecart_recs',
          target: this.ometriaTargetSelector,
        },
      ],
      // Ensure products data is included so current_element.products is populated
      include: ['products'],
      url: sidecartUrl,
      args: {
        query: sidecartUrl,
        region: window.ometriaRegion,
      },
      page_context: {
        currency_id: window.ometriaCurrency || window.Shopify?.currency?.active,
      },
      success: response => {
        // Handle success - section-async elements will load automatically
        this.initializeProductCards()
        this.waitForSectionAsyncToFinish().then(() => {
          this.enforceMobileCarouselLayout()
          this.refreshAccordionMaxHeight()
        })
      },
      error: error => {
        console.warn('Failed to load Ometria sidecart recommendations:', error)
        // Reset hasLoaded so it can try again
        this.hasLoaded = false
      },
    })
  }

  initializeProductCards () {
    // Initialize any product card interactions if needed
    // This can be used to set up quick buy buttons, color swatches, etc.
    const productCards = this.querySelectorAll('[data-ometria-sidecart-card]')
    productCards.forEach(card => {
      // Add any initialization logic here if needed
    })
  }

  refreshAccordionMaxHeight () {
    const itemEl = this.container?.querySelector(
      '[data-accordion-group-el="item"]',
    )
    if (!itemEl) return
    if (itemEl.getAttribute('aria-expanded') !== 'true') return

    const contentEl = itemEl.querySelector(
      '[data-accordion-group-el="content"]',
    )
    if (!contentEl) return

    itemEl.style.setProperty('--Max_Height', `${contentEl.offsetHeight}px`)
  }

  waitForSectionAsyncToFinish () {
    const sectionAsyncEls = Array.from(
      this.container?.querySelectorAll('section-async') || [],
    )
    if (sectionAsyncEls.length === 0) return Promise.resolve()

    const maxChecks = 30
    const checkIntervalMs = 100
    let checks = 0

    return new Promise(resolve => {
      const check = () => {
        checks++
        const stillBusy = sectionAsyncEls.some(
          el => el.getAttribute('aria-busy') === 'true',
        )

        if (!stillBusy || checks >= maxChecks) {
          resolve()
          return
        }

        setTimeout(check, checkIntervalMs)
      }

      check()
    })
  }

  enforceMobileCarouselLayout () {
    if (!this.hasAttribute('data-mobile')) return
    if (!this.ometriaElement) return

    const cards = Array.from(
      this.ometriaElement.querySelectorAll('[data-ometria-sidecart-card]'),
    )
    if (cards.length === 0) return

    const parents = new Set()
    cards.forEach(card => {
      const parent = card.parentElement
      if (parent) parents.add(parent)

      card.style.flex = '0 0 270px'
      card.style.minWidth = '270px'
      card.style.width = '270px'
      card.style.scrollSnapAlign = 'start'
    })

    parents.forEach(parent => {
      parent.style.display = 'flex'
      parent.style.flexWrap = 'nowrap'
      parent.style.gap = '10px'
    })

    const productCards = Array.from(
      this.ometriaElement.querySelectorAll('[data-push-cart-product-card]'),
    )
    productCards.forEach(card => {
      card.style.maxWidth = '270px'
      card.style.minWidth = '270px'
      card.style.width = '270px'
      card.style.scrollSnapAlign = 'start'
    })

    // Ensure the carousel opens from the first card.
    this.resetCarouselScroll()
  }

  resetCarouselScroll () {
    const scrollContainers = [
      ...Array.from(
        this.container?.querySelectorAll('[data-ometria-carousel]') || [],
      ),
      ...Array.from(
        this.container?.querySelectorAll('[data-ometria-products-element]') ||
          [],
      ),
    ]

    scrollContainers.forEach(container => {
      container.scrollLeft = 0
    })
  }
}

if (!customElements.get('push-cart-ometria')) {
  customElements.define('push-cart-ometria', PushCartOmetria)
}
